export function htmlToTextareaValue(html = "") {
  if (!html) return "";

  const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(html);

  if (!looksLikeHtml) {
    return html;
  }

  const withBreaks = html
    .replace(/<\s*br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|li|h[1-6]|tr)\s*>/gi, "\n")
    .replace(/<\s*(p|div|li|h[1-6]|tr)(\s[^>]*)?>/gi, "");

  const doc = new DOMParser().parseFromString(withBreaks, "text/html");
  let text = doc.body.textContent || "";

  return text
    .replace(/\u00A0/g, " ")
    .replace(/\r\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}